import React, { useState } from 'react';
import styles from './Tooltip.module.scss';

type TooltipProps = {
  className?: string;
  message?: string;
  title?: string;
  position?: 'top_center' | 'top_left' | 'top_right' | 'bottom_center' | 'bottom_left' | 'bottom_right';
  width?: string | number;
  type?: 'default' | 'icon' | 'text';
  text?: string;
};

const Tooltip: React.FC<TooltipProps> = ({ className = '', message, title, position = 'top_center', width, type = 'default', text }) => {
  const [show, setShow] = useState(false);

  return (
    <span className={[styles.tooltip, className].join(' ')}>
      {show && (
        <span className={[styles['tooltip_bubble'], styles[`tooltip_bubble_${position.split('_')[0]}`],
          styles[`tooltip_bubble_${position}`]].join(' ')}
          style={{ width: width || 'auto' }}>
          <div>{title}</div>
          <label>{message}</label>
        </span>
      )}
      {type === 'text' ? (
        <span
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
        >
          {text}
        </span>
      ) : (
        <img
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          src={`/images/icon-tooltip.png`}
          alt="info"
        />
      )}
    </span>
  );
};

export default Tooltip;